import React from 'react';
import PropTypes from 'prop-types';
import dayjs from 'dayjs';

const SmallFlowTable = ({ initiatedFlows, subprocessRequirementId }) => {
  const renderRow = (flow) => {
    const params = subprocessRequirementId ? `?subprocess_requirement_id=${subprocessRequirementId}` : '';

    const processURL = `/initiated_flows/manager/${flow.id}${params}`;

    const linkHTML = (
      <a
        className='spanlink'
        href={processURL}
      />
    );

    return (
      <tr key={flow.id}>
        <td>
          {linkHTML}
          <strong>#{flow.scoped_id}</strong>
        </td>
        <td>
          {linkHTML}
          <span>{flow.identifier_field}</span>
        </td>
        <td>
          {linkHTML}
          {dayjs(flow.created_at).format('LLL')}
        </td>
        <td className='strong'>
          {linkHTML}
          <span dangerouslySetInnerHTML={{ __html: flow.status }} />
          { flow.is_renewable
            && (
              <button
                onClick={() => { document.location = processURL; }}
                type='button'
                className='nomargin inline-block margin-left-more'
              >
                Renew
              </button>
            )}
        </td>
      </tr>
    );
  };

  const renderRows = () => {
    return initiatedFlows.map(renderRow);
  };

  return (
    <table className='datatable highlightable margin-bottom middle fullwidth'>
      <thead>
        <tr>
          <th>ID</th>
          <th>Identifier</th>
          <th>Started</th>
          <th>Status</th>
        </tr>
      </thead>
      <tbody>
        {renderRows()}
      </tbody>
    </table>
  );
};

export default SmallFlowTable;
